import * as CryptoJS from 'crypto-js';

export class PasswordUtils {
    private static passPhrase = 'tempP@woDFESjhd';

    public static encryptPassword(password: string): string {
        return CryptoJS.AES.encrypt(password, PasswordUtils.passPhrase ).toString();
    }

    public static checkPasswordRules(password: any) {
        var decimal = /^(?=.*\d)(?=.*[@$!%*?&])(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,50}$/;
        return password.match(decimal);
    }
}

